import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Toggle from "../Components/Toggle";
import { Link } from "react-router-dom";

const BookAppointment = () => {
	const [selectedHour, setSelectedHour] = useState("10.30");

	const hours = [
		"08.00 PM",
		"08.30 PM",
		"09.00 PM",
		"09.30 AM",
		"10.00 AM",
		"10.30 AM",
		"11.00 AM",
		"11.30 AM",
		"12.00 AM",
	];

	const handleHourClick = (hour) => {
		setSelectedHour(hour);
	};
	const [date, setDate] = useState(new Date(2024, 6, 1)); // July 2024

	const onChange = (newDate) => {
		setDate(newDate);
	};

	return (
		<>
			<Header />
			<PageHeader pagename="Book Appointment" />
			<section className="book-appointment pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-5 pe-5">
							<h3 className="main-heading-font dark-color level-3 text-start mb-4">
								Select Hour
							</h3>
							<form>
								<div className="row">
									{hours.map((hour, index) => (
										<div className="col-lg-4 mt-3" key={index}>
											<div
												className={`select-hour-bg ${
													selectedHour === hour ? "active" : ""
												}`}
												onClick={() => handleHourClick(hour)}
											>
												<h4>{hour}</h4>
											</div>
										</div>
									))}
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Toggle
											heading="Share Medical Reports"
											initialState={false}
											containerClassName="symptoms-container d-flex align-items-center justify-content-between mt-3 border-bottom mb-2 pb-3"
										/>
									</div>{" "}
								</div>
								<div className="row  mt-3">
									<div class="form-group col-lg-12">
										<div className="custom-select-wrapper">
											<h5 className="main-heading-font dark-color level-6 mb-2">
												Enter Details
											</h5>
											<select
												className="form-control custom-select"
												id="symptoms"
											>
												<option value="">Enter Symptoms</option>
												<option value="email1@example.com">
													email1@example.com
												</option>
												<option value="email2@example.com">
													email2@example.com
												</option>
												<option value="email3@example.com">
													email3@example.com
												</option>
											</select>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<h5 className="main-heading-font dark-color level-6 mb-2">
											Enter Details
										</h5>
										<div class="form-group">
											<textarea
												class="form-control"
												id="message"
												rows="4"
												placeholder="Enter Details"
											></textarea>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link
											class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration- mt-2"
											to="/book-appointment-payment"
										>
											<span class="bg-wrapper w-100">Make Appointment</span>
										</Link>
									</div>
								</div>
							</form>
						</div>
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<div className="calender-main">
								<div className="calendar-container">
									<div className="calendar-header">
										<span className="main-heading-font dark-color level-5 text-start ">
											Select Date
										</span>
									</div>
									<Calendar
										onChange={onChange}
										value={date}
										view="month"
										minDetail="month"
										nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
										prevLabel={<FontAwesomeIcon icon={faChevronLeft} />}
										next2Label={null}
										prev2Label={null}
									/>
								</div>
								{/* <p>Selected Date: {date.toDateString()}</p> */}
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default BookAppointment;
